import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { catchError, throwError } from 'rxjs'

const USER_PROFILE_KEY = 'user_profile'
const ADMIN_PROFILE_KEY = 'admin_profile'

const isManagementPath = (url: string) => (
  url.startsWith('/admin') ||
  url.startsWith('/super-admin') ||
  url.startsWith('/admin-login')
)

const isApiRequest = (url: string) => (
  url.startsWith('/api') || url.includes('/api/')
)

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router)
  const path = (router.url || '').split('?')[0].split('#')[0]
  const adminScope = isManagementPath(path)
  const profileKey = adminScope ? ADMIN_PROFILE_KEY : USER_PROFILE_KEY

  if (isApiRequest(req.url)) {
    req = req.clone({
      withCredentials: true
    })
  }

  return next(req).pipe(
    catchError(error => {
      if (error.status === 401) {
        localStorage.removeItem(USER_PROFILE_KEY)
        localStorage.removeItem(ADMIN_PROFILE_KEY)
        localStorage.removeItem(profileKey)
        router.navigate([adminScope ? '/admin-login' : '/login'])
      }
      return throwError(() => error)
    })
  )
}
